module.exports = __webpack_public_path__ + "static/media/loading.dfc0cda6.gif";